export class BuildingColors {
  static BRIGHT_YELLOW = '#FFFFBE';
  static YELLOW = '#FFD400';
  static ORANGE = '#F17D00';
  static RED = '#FF0000';
  static MEDIUM_PURPLE = '#9370DB';
  static DARK_PURPLE = '#9300ff'
  static FUCHSIA = '#FF00FF'
}